import { useMemo, useState } from 'react';
import { Optional } from '../../Common/interfaces';

export function useSyncedState<T>(initial: T): [T, (value: T) => void] {
    const [stored, updateStored] = useState(initial);
    const [value, setValue] = useState(initial);

    if (stored !== initial) {
        updateStored(initial);
        setValue(initial);
    }

    return [value, setValue];
}

export function useSyncedStateForJSONArrays(
    initial: Optional<string>,
    minSize: number,
): [string[], (value: string[]) => void] {
    const [stored, updateStored] = useState(initial);
    const parsed = useMemo(
        () => ensureMinSize(JSON.parse(initial ?? '[]'), minSize),
        [initial],
    );
    const [value, setValue] = useState(parsed);

    if (stored !== initial) {
        updateStored(initial);
        setValue(parsed);
    }

    return [value, setValue];
}

export function parseArray(value: Optional<string>): string[] {
    return JSON.parse(value ?? '[]');
}

export function stringifyArray(arr: string[]): string {
    return JSON.stringify(arr.map(normalizeInput).filter(Boolean));
}

function ensureMinSize(array: string[], minSize: number): string[] {
    if (array.length >= minSize) return array;

    array = array.slice();
    while (array.length < minSize) {
        array.push('');
    }
    return array;
}

export function normalizeInput(input: Optional<string>): Optional<string> {
    input = input?.trim();
    return input ? input : null;
}
